import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import axios from "axios";

const GeneesmiddelApi = {
    search(filterModel) {
        const url = prependRoot(`/geneesmiddel/search`, getApiRoot());
        return axios.put(
            url,
            filterModel,
            {
                headers: {
                    'accept': 'application/json'
                }
            });
    },
    get(id) {
        const url = prependRoot(`/geneesmiddel/get/` + id, getApiRoot());
        return axios.get(
            url,
            {
                headers: {
                    'accept': 'application/json'
                }
            });
    },
    listByAutocomplete(filter) {
        const url = prependRoot(`/geneesmiddel/search?naam=${filter}`, getApiRoot());
        return axios.get(
            url,
            {
                headers: {
                    'accept': 'application/json'
                }
            }
        );
    }
};

export default GeneesmiddelApi;